module.exports = __webpack_public_path__ + "static/media/1.5805c40a.JPG";